import React from 'react';
import MasterCard from './components/MasterCard.js';

function App() {
  return (
    <MasterCard/>
  );
}

export default App;
